import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideEntrepriseStub } from '../../../../config/aides-entreprises';

export default function FondsChaleurPage() {
  const aide = getAideEntrepriseStub('fonds-chaleur');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="entreprises" />;
}
